module.exports = __webpack_public_path__ + "img/mouse-face.e89ff39c.png";